import { render, staticRenderFns } from "./corporateInformation.vue?vue&type=template&id=d93681e2&scoped=true&"
import script from "./corporateInformation.vue?vue&type=script&lang=js&"
export * from "./corporateInformation.vue?vue&type=script&lang=js&"
import style0 from "./corporateInformation.vue?vue&type=style&index=0&id=d93681e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93681e2",
  null
  
)

export default component.exports